<template>
  <transition name="fade">
    <div class="toast-container" v-show="showToast">

      <div class="message-field" :style="{width: styles.width, top: styles.top, left: styles.left}">
        {{message}}
      </div>

    </div>
  </transition>
</template>

<script>
export default {
  name: 'MyToast',
  props: {
    message: '',
    toast: false,
    styles: {
      type: Object,
      default: function () {
        return {
          top: '50%',
          left: '50%',
          width: '440px'
        }
      }
    }
  },
  computed: {
    showToast: {
      get: function () {
        return this.toast
      },
      set: function (v) {
        this.toast = v
      }
    }
  },
  data () {
    return {}
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .toast-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .message-field {
      width: 440px;
      padding: 40px 90px;
      background: rgba(0, 0, 0, .7);
      border-radius: 8px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      font-size: 16px;
      color: #FFFFFF;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */
  {
    opacity: 0
  }

  @media (-webkit-min-device-pixel-ratio:2),(min-device-pixel-ratio:2){
    .toast-container {
      .message-field {
        padding: 20px 40px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/MyToast.vue